import Vue from 'vue';
import _ from 'lodash';
import {
    GET_CLIENT_LIST_PROMOT_REQUEST,
    GET_CLIENT_LIST_PROMOT_SUCCESS,
    GET_CLIENT_LIST_PROMOT_FAILURE,
    GET_STORE_PROMOT_CONFIG_REQUEST,
    GET_STORE_PROMOT_CONFIG_SUCCESS,
    GET_STORE_PROMOT_CONFIG_FAILURE,
    RESOLVE_CLIENT_PROMOT_USER_LIST_PARAMS,
    UPDATE_CLIENT_PROMOT_CONFIG,
    UPDATE_CLIENT_LIST_STATUS,
    GET_CARS_BY_MOBILE_REQUEST,
    GET_CARS_BY_MOBILE_SUCCESS,
    GET_CARS_BY_MOBILE_FAILURE,
    RESET_CLIENT_PROMOT_STATE
} from '../mutationTypes';

const state = {
    loading: false,
    confLoading: false,
    carsLoading: false,
    // 请求参数
    page: 1,
    pageSize: 10,
    name: '',
    mobile: '',
    carNo: '',
    reqParams: {},
    // 返回数据
    list: [],
    pageCount: 1,
    promotOrderId: '',
    promotRange: 0, // 营销周期, 天
    promotTimes: 0, // 周期内次数
    messageLeft: 0, // 短信剩余
    // 车辆列表选择radio用
    carsList: [], // 弹窗中用户车辆
};

const mutations = {
    [GET_CLIENT_LIST_PROMOT_REQUEST](state) {
        state.loading = true;
    },
    [GET_CLIENT_LIST_PROMOT_SUCCESS](state, res) {
        state.loading = false;

        state.pageCount = res.page_count;
        state.list = res.user_list;
    },
    [GET_CLIENT_LIST_PROMOT_FAILURE](state) {
        state.loading = false;
    },
    [GET_STORE_PROMOT_CONFIG_REQUEST](state) {
        // 每次营销之后重新请求
        state.confLoading = true;
    },
    [GET_STORE_PROMOT_CONFIG_SUCCESS](state, res) {
        state.confLoading = false;

        state.promotRange = res.promot_range;
        state.promotTimes = res.promot_times;
        state.messageLeft = res.message_left;
    },
    [GET_STORE_PROMOT_CONFIG_FAILURE](state) {
        state.confLoading = false;
    },
    [RESOLVE_CLIENT_PROMOT_USER_LIST_PARAMS](state, params) {
        state.reqParams = params;
    },
    [UPDATE_CLIENT_PROMOT_CONFIG](state, config) {
        const {
            mobile, carNo,
            page, name
        } = config;

        if (mobile || mobile === '') state.mobile = mobile;
        if (carNo || carNo === '') state.carNo = carNo;
        if (name || name === '') state.name = name;
        if (page) {
            state.page = page;
            state.reqParams.page = page;
        }
    },
    [UPDATE_CLIENT_LIST_STATUS](state, { i, k, v }) {
        if (!k && !v && i >= state.list.length - 1) {
            return;
        }
        state.list[i][k] = v;
    },
    [GET_CARS_BY_MOBILE_REQUEST](state) {
        state.carsLoading = true;
    },
    [GET_CARS_BY_MOBILE_SUCCESS](state, res) {
        state.carsLoading = false;

        state.carsList = res.car_list;
    },
    [GET_CARS_BY_MOBILE_FAILURE](state) {
        state.carsLoading = false;
    },
    [RESET_CLIENT_PROMOT_STATE](state) {
        _.extend(state, _.cloneDeep({
            loading: false,
            confLoading: false,
            carsLoading: false,
            // 请求参数
            page: 1,
            pageSize: 10,
            name: '',
            mobile: '',
            carNo: '',
            reqParams: {},
            // 返回数据
            list: [],
            pageCount: 1,
            promotOrderId: '',
            promotRange: 0, // 营销周期, 天
            promotTimes: 0, // 周期内次数
            messageLeft: 0, // 短信剩余
            // 车辆列表选择radio用
            carsList: [], // 弹窗中用户车辆
        }));
    }
};

export const actions = {
    async getClientPromotList({ commit }) {
        commit(GET_CLIENT_LIST_PROMOT_REQUEST);

        const res = await Vue.$ajax.get('getMaintainUserList', state.reqParams);

        if (!res.errorType) {
            // console.log(res);
            commit(GET_CLIENT_LIST_PROMOT_SUCCESS, res);
        } else {
            commit(GET_CLIENT_LIST_PROMOT_FAILURE);
        }
    },
    async getStorePromotConfig({ commit }) {
        commit(GET_STORE_PROMOT_CONFIG_REQUEST);

        const res = await Vue.$ajax.get('storeMessageConfig');

        if (!res.errorType) {
            commit(GET_STORE_PROMOT_CONFIG_SUCCESS, res);
        } else {
            commit(GET_STORE_PROMOT_CONFIG_FAILURE);
        }
    },
    async getCarsByMobile({ commit }, mobile) {
        commit(GET_CARS_BY_MOBILE_REQUEST);

        const res = await Vue.$ajax.get('carList', { mobile });

        if (!res.errorType) {
            commit(GET_CARS_BY_MOBILE_SUCCESS, res);
        } else {
            commit(GET_CARS_BY_MOBILE_FAILURE);
        }
    },
    getPromotMaintenance({ commit }) {
        commit();
    },

    clientPromotParams({ commit }) {
        const {name, mobile, carNo, page, pageSize} = state;
        const params = {
            user_name: name,
            user_mobile: mobile,
            car_no: carNo,
            page,
            pagesize: pageSize,
        };

        commit(RESOLVE_CLIENT_PROMOT_USER_LIST_PARAMS, params);
    },
    resetClientPromot({ commit }) {
        commit(RESET_CLIENT_PROMOT_STATE);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/clientPromot.js